import type { JSX } from 'react';
import { useColorPickerState } from './ColorPickerContext';
import { ColorSwatch } from './ColorSwatch';
import { Text } from '../Text';

export const ContrastPreview = (): JSX.Element => {
  const { valueAsHex, colorForComparison } = useColorPickerState();
  return (
    <ColorSwatch
      diameterPx={36}
      value={valueAsHex}
    >
      <Text style={{ color: colorForComparison }}>Aa</Text>
    </ColorSwatch>
  );
};
